import { decimal } from '@snap-types/schemas/decimal';
import { z } from 'zod/v4';

import { originalSourceSchema } from '../enums';
import {
  partEngineeringStatusSchema,
  partEngineeringTypeSchema,
} from '../part-engineering/enums';
import { unitsPerPieceTypeSchema } from './enums';

export const columns = {
  id: z.string(),
  engType: partEngineeringTypeSchema,
  engStatus: partEngineeringStatusSchema,
  baseId: z.string(),
  lotId: z.string(),
  splitId: z.string(),
  subId: z.string(),
  sequenceNum: z.number(),
  pieceNum: z.number(),
  unitsPerPiece: decimal.nullable(),
  unitsPerPieceType: unitsPerPieceTypeSchema,
  scrapPercent: decimal.nullable(),
  estUnitsPerOpQty: decimal.nullable(),
  estUnitsPerLineQty: decimal.nullable(),
  minMtrlCost: decimal.nullable(),
  usageUM: z.string().nullable(),
  estQty: decimal.nullable(),
  actQty: decimal.nullable(),
  estFixedQty: decimal.nullable(),
  estMatFixedCost: decimal.nullable(),
  estUnitMatCost: decimal.nullable(),
  estUnitLabCost: decimal.nullable(),
  estUnitBurCost: decimal.nullable(),
  estBurPct: decimal.nullable(),
  /// diff than unit cost
  estBurPerUnit: decimal.nullable(),
  estUnitSrvCost: decimal.nullable(),
  estMatCostTotal: decimal.nullable(),
  estLabCostTotal: decimal.nullable(),
  estBurCostTotal: decimal.nullable(),
  estSrvCostTotal: decimal.nullable(),
  actMatCostTotal: decimal.nullable(),
  actLabCostTotal: decimal.nullable(),
  actBurCostTotal: decimal.nullable(),
  actSrvCostTotal: decimal.nullable(),

  originalSource: originalSourceSchema,

  reqPartId: z.string().nullable(),
  reqPartOriginalSource: originalSourceSchema.nullable(),
  siteId: z.string(),

  quotingConfigId: z.string().nullable(),
  quotingConfigHistoryIds: z.array(z.string()),

  createdById: z.string().nullable(),
  createdByService: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
};
